import React from 'react';
import { Link } from 'react-router-dom';
import ImageTransformProcessor from './ImageTransformProcessor';
import './Homework1.css';

const Homework2: React.FC = () => {
  return (
    <div className="homework-page">
      <div className="homework-header animate-fade-in-up">
        <div className="header-background">
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
        </div>

        <div className="header-content">
          <div className="nav-section">
            <Link to="/" className="back-button">
              <span className="back-icon">←</span>
              <span>Back to Hub</span>
            </Link>
          </div>

          <div className="hero-content">
            <div className="hw-badge">
              <span className="badge-text">Assignment 2</span>
            </div>

            <div className="hw-title">
              <h1>Image Transformations & Color Spaces</h1>
              <div className="title-decoration"></div>
            </div>

            <div className="hw-description">
              <p>
                Master advanced image processing techniques with geometric transformations
                and color space conversions. Apply reflections, resizing, cropping, and explore
                multiple color representation systems including HSI, HSV, and YIQ.
              </p>

              <div className="feature-highlights">
                <div className="highlight">
                  <div className="highlight-icon">🔄</div>
                  <span>Geometric Transforms</span>
                </div>
                <div className="highlight">
                  <div className="highlight-icon">🎨</div>
                  <span>Color Space Conversions</span>
                </div>
                <div className="highlight">
                  <div className="highlight-icon">⚡</div>
                  <span>Real-time Processing</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="homework-content animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
        <ImageTransformProcessor />
      </div>
    </div>
  );
};

export default Homework2;
